import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ImpactSection } from "@/components/sections/ImpactSection";
import { CTASection } from "@/components/sections/CTASection";
import { SEO } from "@/components/SEO";

const Impact = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Impact & Outcomes | It's All About Growth"
        description="Outcomes from prior engagements: pipeline lifted, CAC reduced, conversion compounded, and revenue systems that keep working after we leave."
        path="/impact"
      />
      <Header />
      <main className="pt-20">
        <ImpactSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Impact;
